// extracted by mini-css-extract-plugin
export var container = "page-module--container--9cafc";
export var inner = "page-module--inner--5fa9e";